module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-move-asset"
  }, [_c('button', {
    staticClass: "button small",
    on: {
      "click": function($event) {
        _vm.moveEnabled = !_vm.moveEnabled
      }
    }
  }, [_vm._v("Move")]), (_vm.moveEnabled) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "close-button",
    on: {
      "click": function($event) {
        _vm.moveEnabled = false
      }
    }
  }, [_vm._v("x")]), _c('h2', [_vm._v("Select the parking slot")]), _c('selectize-grouped-parking-assets', {
    on: {
      "parkingSlotSelected": _vm.parkingSlotSelected
    }
  }), _c('div', {
    staticClass: "button-group"
  }, [(_vm.parking_slot_id) ? _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.move
    }
  }, [_vm._v("Move")]) : _vm._e()])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-49c0dba8!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/asset-management/MoveAsset.vue
// module id = 2255
// module chunks = 1